import { render, staticRenderFns } from "./index_multiselect.vue?vue&type=template&id=2b18be24&scoped=true"
import script from "./index_multiselect.vue?vue&type=script&lang=js"
export * from "./index_multiselect.vue?vue&type=script&lang=js"
import style0 from "./index_multiselect.vue?vue&type=style&index=0&id=2b18be24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18be24",
  null
  
)

export default component.exports